/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum indicating the type of a Form Component.
 */
export enum FormElementType {
    ACTION_BUTTON = 'ActionButton',
    BOOLEAN = 'Boolean',
    CASCADER = 'Cascader',
    CHECKBOXES = 'Checkboxes',
    DATE = 'Date',
    DISCUSSION = 'Discussion',
    FILE_UPLOAD = 'FileUpload',
    ANSWER_REVIEW = 'AnswerReview',
    FORM_TEXT = 'FormText',
    MAILING_ADDRESS = 'MailingAddress',
    MONEY = 'Money',
    NUMBER = 'Number',
    HEADING = 'Heading',
    RADIO_BUTTONS = 'RadioButtons',
    REPEATER = 'Repeater',
    RICH_TEXT = 'RichText',
    SECTION = 'Section',
    SECURITY_GROUP = 'SecurityGroup',
    SELECT_LIST = 'SelectList',
    APPLICATION_STATUS_SELECT = 'ApplicationStatusSelect',
    SIMPLE_TEXT = 'SimpleText',
    CHANGE_STATUS_BUTTON = 'ChangeStatusButton',
    NAME_STAMP = 'NameStamp',
    LINKED_ANSWER = 'LinkedAnswer',
    COMPLIANCE_ITEM = 'ComplianceItem',
    DIVIDER = 'Divider',
    ENTITY = 'Entity',
    USER_SELECT = 'UserSelect',
    WORKFLOW_ASSOCIATION = 'WorkflowAssociation',
    ACTIVITY_DATE = 'ActivityDate',
    PRIMARY_CONTACT_SELECT = 'PrimaryContactSelect',
    ENVIRONMENT_INDICATOR = 'EnvironmentIndicator',
}
